import { useMutation, UseMutationResult, useQueryClient } from "@tanstack/react-query";
import { apiFetch } from "../APIClient";
import {
  CreateReservationRequestRequestDto,
  RequestReservationResponseDto,
} from "../generated/generatedTypes";

const requestReservation = async (
  payload: CreateReservationRequestRequestDto
): Promise<RequestReservationResponseDto> => {
  const response = await apiFetch("api/reservation/confirm-portone-payment-and-request", {
    method: "POST",
    body: JSON.stringify(payload),
    headers: {
      "Content-Type": "application/json",
    },
  });

  if (!response.ok) {
    // Attempt to parse error details if available
    let errorMessage = "예약 요청을 제출하지 못했습니다.";
    try {
      const errorData = await response.json();
      errorMessage = errorData.message || errorMessage;
    } catch (e) {
      // Ignore if error response is not JSON or empty
    }
    throw new Error(errorMessage);
  }

  const data = await response.json();
  return data as RequestReservationResponseDto;
};

export function useRequestReservation(): UseMutationResult<
  RequestReservationResponseDto,
  Error,
  CreateReservationRequestRequestDto
> {
  const queryClient = useQueryClient();
  return useMutation<RequestReservationResponseDto, Error, CreateReservationRequestRequestDto>({
    mutationFn: requestReservation,
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ["myUpcomingReservations"] });
      queryClient.invalidateQueries({ queryKey: ["myLatestReservation"] });
    },
    onError: (error) => {
      console.error("Reservation request failed:", error);
    },
    // onSuccess, onError, onSettled can be handled by the component using the hook
    // or defined here if there are common side effects.
  });
}
